import { useEffect,useState } from 'react'
import { Alert, Box, Card, CardContent, Grid } from '@mui/material'
import { post } from '../../../utils/axios'

const ChildSegments = () => {
    const [isLoading,setIsLoading] = useState(true)
    const [userSegments,setUserSegments] = useState([])
    
    useEffect(() => {
        post('ChildUser/GetTrasactionListChildUser').then(({data}) => {
            if(data.isSuccess)
                setUserSegments(data.data)
        }).finally(() => {
            setIsLoading(false)
        })
    },[])

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">لیست منابع مالی تخصیص یافته</h3>
            <div className="safe-area">
                {isLoading ? [...Array(4)].map((item,index) => <Card sx={{width: '100%',mb: 2}} key={index}>
                    <CardContent sx={{py: 3,pb: 4}}>
                        <div className="child-row-placeholder">
                            <h4 className="segment-placeholder animate"></h4>
                            <p className="limited-usage-placeholder animate"></p>
                            <p className="limited-usage-placeholder animate"></p>
                        </div>
                    </CardContent>
                </Card>) : (userSegments.length ? <>
                    <Box sx={{mb: 15}}>
                        {userSegments.map(segment => <Card sx={{ width: '100%',mb: 2 }} key={segment.id}>
                            <CardContent sx={{ py: 3,pb: 4 }} className={`segment-box ${segment.isExpired ? 'deactivated-segment' : ''}`}>
                                {segment.isExpired ? <span className="alaram-deactivated-segment">غیرفعال</span> : ''}
                                <h4>{segment.segment}</h4>
                                <p className="limited-usage">سقف میزان قابل استفاده : <span>{segment.limitPercent ? `${segment.limitPercent} درصد و ` : ''}مبلغ {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(segment.limit)}</span> ریال</p>
                                <p className="limited-usage">میزان استفاده شده : <span>مبلغ {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(segment.purchaseAmount)}</span> ریال</p>
                                <p className="limited-usage">میزان قابل استفاده فعلی : <span>مبلغ {new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(segment.reminder)}</span> ریال</p>
                                <p className="time-usage">از تاریخ <span>{segment.fromDate}</span> الی <span>{segment.toDate}</span></p>
                            </CardContent>
                        </Card>)}
                    </Box>
                </> : <Alert severity="info" sx={{mb: 2}}>منبع مالی برای شما ثبت نشده است</Alert>)}
            </div>
        </Grid>
    )
}

export default ChildSegments